import type { Card } from '../../types';

/** Epic defense with a Weaken rider — block plus debuff (§3). */
export const AEGIS: Card = {
  id: 'aegis',
  name: 'Aegis',
  type: 'defense',
  rarity: 'epic',
  size: { w: 2, h: 2 },
  cost: [
    { kind: 'min', value: 5 },
    { kind: 'min', value: 3 },
  ],
  effects: [
    { kind: 'block', amount: 12 },
    {
      kind: 'applyStatus',
      application: { status: 'weaken', magnitude: 2, duration: 2, target: 'opponent' },
    },
  ],
};
